var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.53 27.15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#126CFC;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.26,19.12V1.5a1.5,1.5,0,0,1,3,0V19.12a1.5,1.5,0,0,1-3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,14.39A1.51,1.51,0,0,1,8.55,13.3l5.21,5,5.22-5a1.5,1.5,0,1,1,2.07,2.17l-6.25,6a1.5,1.5,0,0,1-2.07,0l-6.26-6A1.52,1.52,0,0,1,6,14.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.79,18.38v3.31a2.73,2.73,0,0,1-2.73,2.73H5.47a2.73,2.73,0,0,1-2.73-2.73V18.38H0v3.31a5.47,5.47,0,0,0,5.47,5.46H22.06a5.47,5.47,0,0,0,5.47-5.46V18.38Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNy41MyAyNy4xNSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMxMjZDRkM7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5Eb3dubG9hZDwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMi4yNiwxOS4xMlYxLjVhMS41LDEuNSwwLDAsMSwzLDBWMTkuMTJhMS41LDEuNSwwLDAsMS0zLDBaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNiwxNC4zOUExLjUxLDEuNTEsMCwwLDEsOC41NSwxMy4zbDUuMjEsNSw1LjIyLTVhMS41LDEuNSwwLDEsMSwyLjA3LDIuMTdsLTYuMjUsNmExLjUsMS41LDAsMCwxLTIuMDcsMGwtNi4yNi02QTEuNTIsMS41MiwwLDAsMSw2LDE0LjM5WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI0Ljc5LDE4LjM4djMuMzFhMi43MywyLjczLDAsMCwxLTIuNzMsMi43M0g1LjQ3YTIuNzMsMi43MywwLDAsMS0yLjczLTIuNzNWMTguMzhIMHYzLjMxYTUuNDcsNS40NywwLDAsMCw1LjQ3LDUuNDZIMjIuMDZhNS40Nyw1LjQ3LDAsMCwwLDUuNDctNS40NlYxOC4zOFoiLz48L2c+PC9nPjwvc3ZnPg==";